import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// Visible only when the selected size has location === 1.

const DoorLiteLocation = ({ value = 'Center', onChange, isVisible = 0, label = 'Location' }) => {
    const [selected, setSelected] = useState(value);

    useEffect(() => {
        if (isVisible === 1) {
            setSelected('Center');
            onChange('Center');
        }
    }, [isVisible]);

    if (isVisible !== 1) return null;

    const handleChange = (e) => {
        setSelected(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="DoorLiteLocation">{label}</label>
            <select id="DoorLiteLocation" value={selected} onChange={handleChange}>
                <option value="LockSide">Lock Side</option>
                <option value="Center">Center</option>
                <option value="HingeSide">Hinge Side</option>
            </select>
        </div>
    );
};

export default DoorLiteLocation;
